// @flow
import React from "react";
import dayjs from "dayjs";
import MenuButton from "root/components/MenuButton/MenuButton";
import SVG_ICONS from "~/assets/icons/icons";

type Props = {
    onGoBack: Function,
    albumData: Object
};

export const AlbumBar = (props: Props) => <div className="flex flex-row items-center w-100 h-100 ml3 mr3" data-test="album-bar">
	<MenuButton iconSize={22} icon={SVG_ICONS.BACK} onClick={props.onGoBack} dataTest="go-back"/>
	<div className="ml3 mr3 f3" data-test="album-title">
		{props.albumData.name || ""}
	</div>
	<div className="f6" data-test="album-date">
		{dayjs(props.albumData.created_time).format("ll")}
	</div>
</div>;


export default AlbumBar;
